<template>
    <div id="prjMemberGrid">
        <b-form-group class="mb-0 m">
            <b-form-input id="filter-input" v-model="filterInput" type="search" placeholder="Enter to Search" class="mb-0"
                v-on:keyup.enter="filter = filterInput"></b-form-input>
        </b-form-group>

        <b-table head-variant="light" :fields="fields" style="width:100%; max-height: 29.3em;" id="my-table" :items="items" :filter="filter" responsive small sticky-header
            :filter-included-fields="filterOn" @filtered="onFiltered" class="mb-0 table-wrap">

            <template #cell(role)="row">
                {{ row.item.role }}
            </template>
            <template #cell(duration)="row">
                <span v-if="row.item.roleIn && row.item.roleOut">{{ row.item.roleIn }}~{{ row.item.roleOut }}</span>
            </template>
            <template #cell(engagementRate)="row">
                <span v-if="row.item.engagementRate">{{ row.item.engagementRate }}%</span>
            </template>
            <template #cell(show_details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="expand">
                    {{ row.detailsShowing ? '-' : '+' }}
                </b-button>
            </template>

            <template #row-details="row">
                <div id="expanded-info">
                    <div class="inner">
                        <div class="d-flex">
                            <div class="field-wrap">
                                <div class="label-wrap">
                                    <label for="role-options">Role</label>
                                    <div class="toggle-area">
                                        <span class="">Admin</span>
                                        <b-form-checkbox switch v-model="row.item.admin" :value="true"
                                            :unchecked-value="false"></b-form-checkbox>
                                    </div>
                                </div>
                                <div class="input-wrap">
                                    <b-select size="sm" :options="roleOptions" class="mr-2" name="role-options" v-model="row.item.role" />
                                </div>
                            </div>
                            <div class="field-wrap">
                                <div class="label-wrap">
                                    <label for="start-date">Start - End Date</label>
                                </div>
                                <div class="input-wrap date-wrap">
                                    <b-input-group class="form-inline">
                                        <b-form-input id="start-date" name="start-date" type="date" v-model="row.item.roleIn"
                                            class="custom-input  rounded" data-vv-as="start date"
                                            placeholder="YYYY-MM-DD"></b-form-input>
                                    </b-input-group>
                                    <b-input-group class="form-inline">
                                        <b-form-input id="end-date" name="end-date" type="date" v-model="row.item.roleOut"
                                            class="custom-input  rounded" data-vv-as="end date"
                                            placeholder="YYYY-MM-DD"></b-form-input>
                                    </b-input-group>
                                </div>
                            </div>
                        </div>
                        <div class="field-wrap">
                            <div class="label-wrap">
                                <label for="">Engagement-Rate</label>
                            </div>
                            <div class="input-wrap">
                                <b-form-group label-for="sm-opacity" class="mb-0">
                                    <b-input-group>
                                        <b-form-input id="sm-opacity" v-model="row.item.engagementRate" type="range" number
                                            min="0" max="100" step="5"></b-form-input>
                                        <b-input-group-append is-text>
                                            {{ row.item.engagementRate }}%
                                            <!-- <b-form-input type="number" class="text-monospace" v-model="row.item.engagementRate" aria-label="Text input with checkbox"/> -->
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <b-button @click="moveToAvailableFromMembers(row.item)" variant="outline-danger" size="sm" class="btn-unassign">UNASSIGN</b-button>

                
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>
export default {
    props: ['propItems', 'propRoleOptions'],
    components: {},
    data() {
        return {
            roleOptions: [],
            fields: [],
            items: [],
            filter: null,
            filterInput: null,
            filterOn: [],
        }
    },
    created() {
        this.items = this.propItems;
        
        this.fields = [
            {
                key: "userId",
                label: "ID",
                thClass: ["text-center"],
                class: ["text-center", "align-middle"]
            },
            {
                key: "userName",
                label: "Name",
                thClass: ["text-left"],
                class: ["text-center", "align-middle"]

            },
            {
                key: "role",
                label: "Role",
                thClass: ["text-center"],
                class: ["text-center", "align-middle"]
            },
            {

                key: "duration",
                label: "Duration",
                thClass: ["text-center"],
                class: ["text-center", "align-middle"]
            },
            {
                key: "engagementRate",
                label: "Engagement-Rate",
                thClass: ["text-center"],
                class: ["text-center", "align-middle"]
            },

            {
                key: "show_details",
                label: "",
                thClass: ["text-right"],
                class: ["text-right", "align-middle"]
            }

        ]
    },
    
    watch: {
        'propItems': {
            handler() {
                if(this.propItems || this.propItems.length>0){
                    this.items = this.propItems
                }
            },
            deep: true,
            immediate: true // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
        },
        'propRoleOptions': {
            handler() {
                this.roleOptions = [...this.propRoleOptions];
            },
            deep: true,
            immediate: true // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
        }
    },
    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        moveToAvailableFromMembers(user) {
            this.$emit('moveToAvailableFromMembers', user);
        },
    }

}
</script>
<style>
#filter-input {
    height: 2em;
}
#projectNew #prjMemberGrid .btn-secondary.expand,
#projectDetail #prjMemberGrid .btn-secondary.expand {
    width : 20px;
    height: 20px;
    padding : 0px;
    border-radius: 4px;
    vertical-align: middle;
    text-align: center;
    line-height: 20px;
    border: none;
}

#prjMemberGrid #my-table{
    width:100% !important;
}

/* #prjMemberGrid #my-table td, #prjMemberGrid #my-table th{
    padding : 0.3rem !important;
    border : none !important;
} */
#prjMemberGrid .card-body{
    width : 100% !important;
    min-height : 0 !important;
    padding : 1em !important;
}

#prjMemberGrid #expanded-info{
    margin-bottom : 0em !important;
    background-color: #F6F6FA;
}
#prjMemberGrid #expanded-info .card-body{
    padding-bottom : 0em !important;
    margin-bottom : 0em !important;
}

#prjMemberGrid #expanded-info .card-body .btn{
    border-top-right-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-bottom-right-radius: 30px !important;
    border-bottom-left-radius: 30px !important;
    border : none;
}

#prjMemberGrid{
    width : 100% !important;
}

#project-form .table-wrap .table th {
    border-top: none;
}

#project-form .table-wrap .table .b-table-details > td {
    padding: 0;
}

#project-form .table-wrap .table .b-table-details .btn-unassign {
    background: rgba(255, 0, 0, 0.10);
    border: none;
    border-radius: 0;
    color: #F00;
}
#project-form .table-wrap .table .b-table-details .btn-unassign:hover {
    color: #F00;
}

#project-form #expanded-info .inner {
    padding: min(2rem, 1.0416vw);
}

#project-form #expanded-info .d-flex {
    gap: 0 min(2rem, 1.0416vw);
    margin-bottom: min(2rem, 1.0416vw);
}

#project-form #expanded-info .d-flex .field-wrap {
    width: 50%;
}

#project-form #expanded-info .label-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

#project-form #expanded-info .toggle-area {
    display: flex;
    align-items: center;
    gap: 0 8px;
}

#project-form #expanded-info .toggle-area span {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
}

#project-form #expanded-info .custom-switch .custom-control-label::before {
    top: 0;
    width: 32px;
    height: 18px;
    border: none;
    border-radius: 50px;
    background-color: #DDDDE3;
}

#project-form #expanded-info .custom-switch .custom-control-label::after {
    top: 2px;
    left: calc(-2.25rem + 2px);
    width: 14px;
    height: 14px;
    background-color: #FFF;
    border-radius: 80px;
}

#project-form #expanded-info .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #142459;
}

#project-form #expanded-info .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none;
}

#project-form #expanded-info .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #FFF;
    transform: translateX(1rem);
}

#project-form #expanded-info .date-wrap {
    display: flex;
    align-items: center;
    gap: 0 2rem;
}

#project-form #expanded-info .date-wrap .input-group {
    position: relative;
    width: calc(50% - 1rem);
}

#project-form #expanded-info .date-wrap .input-group:first-child::after {
    content: '~';
    display: block;
    position: absolute;
    top: 50%;
    right: -19px;
    transform: translateY(-50%);
    color: #747480;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

#project-form #expanded-info .input-group > .custom-range {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px 0 0 10px;
    border: none;
    background-color: #E7E7EE;
}

#project-form #expanded-info .input-group > .custom-range::-webkit-slider-runnable-track {
    height: 4px;
    background-color: #FFF;
}

#project-form #expanded-info .input-group > .custom-range::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: #747480;
}

#project-form #expanded-info .input-group > .custom-range:focus {
    box-shadow: none;
}

#project-form #expanded-info .input-group .input-group-append {
    margin-left: 0;
}

#project-form #expanded-info .input-group .input-group-append .input-group-text {
    justify-content: center;
    min-width: 80px;
    height: 40px;
    padding: 10px 20px;
    text-align: center;
    background-color: #747480;
    border-radius: 0 10px 10px 0;
    border: none;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
}
</style>